import { render, staticRenderFns } from "./SubjectGroupUpdateDialog.vue?vue&type=template&id=3492672b"
import script from "./SubjectGroupUpdateDialog.vue?vue&type=script&lang=js"
export * from "./SubjectGroupUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports